import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ReactDOM from "react-dom";
import SoftwareDevelopmentService from "./SoftwareDevelopmentService";
import ProjectManagementService from "./ProjectManagementServices";
import ProjectRescueService from "./ProjectRescueServices";
import AnchorLink from "../components/AnchorLinkComponent";


class FullListOfServices extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Available Services</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>These are some of the Services that I can provide:</p>
                        <ul >
                            <li><AnchorLink value="Software Development" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/services/softwaredevelopment'/></li>
                            <li><AnchorLink value="Project Management" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/services/projectmanagement'/></li>
                            <li><AnchorLink value="Distressed Project Rescue" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/services/projectrescue'/></li>
                            <li>Hardware Development</li>
                            <li>Product Manufacturing</li>
                            <li>Process Evaluation</li>
                            <li>Personnel Recruiting and Evaluation</li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default FullListOfServices



// WEBPACK FOOTER //
// src/Services/FullListOfServices.js